import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaOverbookingUpdateRequest, IRotaOverbookingUpdateResponse } from "@/api_framework/api_modals/Rota";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useRotaOverbookingRequestUpdateAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (requestId: string, payload: IRotaOverbookingUpdateRequest): Promise<IRotaOverbookingUpdateResponse> => {
      dispatch(setLoading({ key: "isOverbookingRequestMutationInProgress", status: true }));
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<IRotaOverbookingUpdateResponse> = await axios.patch(
          `${ROTA_APIS?.ROTA_OVERBOOKING_REQUESTS?.baseURL ?? ""}${requestId}/`,
          payload,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (res.data.status === true) {
          toast.success("Overbooking request updated successfully");
          return res.data;
        }

        toast.error(res.data.message ?? "Unable to update overbooking request");
        return res.data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          sendCurl?.(error.config?.["curlCommand"]);
          captureError(error);
          return {
            status: false,
            message: error.response?.data?.message ?? "Failed to update overbooking request",
            data: null,
          };
        }

        const err = error as Error;
        toast.error("Server Error: " + err.message);
        return {
          status: false,
          message: err.message,
          data: null,
        };
      } finally {
        dispatch(setLoading({ key: "isOverbookingRequestMutationInProgress", status: false }));
      }
    },
    [captureError, configuration, dispatch, sendCurl],
  );

  return execute;
};

// Backward-compatible alias
export const useRotaOverBookingRequestUpdateApi = useRotaOverbookingRequestUpdateAPI;
